import { AntMediaProvider } from 'providers/AntMediaProvider'
import { RpSocketProvider } from 'providers/RpSocketProvider'
import { Outlet } from 'react-router-dom'

// const PrivateLayoutInside = observer(() => {
//   const { loginStore } = useStore()
//   const { disconnect: disconnectAntMedia } = useAntMedia()

//   useEffect(() => {
//     return () => {
//       if (!loginStore.isAuthenticated) disconnectAntMedia()
//     }
//   }, [loginStore.isAuthenticated, disconnectAntMedia])

//   return <Outlet />
// })

const PrivateLayout = () => {
  return (
    <AntMediaProvider>
      <RpSocketProvider>
        <Outlet />
      </RpSocketProvider>
    </AntMediaProvider>
  )
}

export default PrivateLayout
